import React from 'react';
import { Container } from 'reactstrap';
import styles from './MaintenancePage.module.scss';
import gear from '@/assets/maintenance.png';

const MaintenancePage = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "100vh", backgroundColor: "#F3F4F6" }}
    >
      <img
        src="https://www.svgrepo.com/show/426192/cogs-settings.svg"
        alt="Maintenance"
        className="img-fluid mb-4"
        style={{ maxWidth: "250px" }}
      />
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-gray-700 mb-4">
        Site is under maintenance
      </h1>
      <p className="text-center text-gray-500 text-lg md:text-xl lg:text-2xl mb-8">
        We're working hard to improve the user experience. Stay tuned!
      </p>
    </div>
  );
};

export default MaintenancePage;
